import type {
  CatalogGroupDTO,
  ClientListResponseDTO,
  VerifyEmailResponse,
} from "sandbox/types";

import { useSandboxQuery } from "./useSandboxApi";

export const useClientsList = () =>
  useSandboxQuery<ClientListResponseDTO>(["sandbox", "clients"], "/clients");

export const useSandboxEndpoints = () =>
  useSandboxQuery<CatalogGroupDTO[]>(["sandbox", "endpoints"], "/endpoints");

export const useVerifyEmailQuery = (token: string) =>
  useSandboxQuery<VerifyEmailResponse>(
    ["verify-email", token],
    `/verify-email?token=${token}`,
    { auth: { mode: "no-auth" } },
  );
